// Formatting helpers
export function fmtMoney(amount, currency = 'USD') {
  const n = Number(amount || 0);
  try {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency, minimumFractionDigits: 2 }).format(n);
  } catch {
    return `$${n.toFixed(2)}`;
  }
}

export function fmtDate(iso, opts = {}) {
  if (!iso) return '—';
  try {
    const d = new Date(iso);
    return d.toLocaleString(opts.locale || 'es-PR', {
      timeZone: 'America/Puerto_Rico',
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit',
    });
  } catch { return iso; }
}

export function fmtDateShort(iso) {
  if (!iso) return '—';
  try {
    const d = new Date(iso);
    return d.toLocaleDateString('es-PR', { timeZone: 'America/Puerto_Rico', year: 'numeric', month: 'short', day: '2-digit' });
  } catch { return iso; }
}

export const STATUS_META = {
  paid: { es: 'Pagado', en: 'Paid', className: 'bg-emerald-50 text-emerald-800 border-emerald-200' },
  pending: { es: 'Pendiente', en: 'Pending', className: 'bg-amber-50 text-amber-800 border-amber-200' },
  voided: { es: 'Anulado', en: 'Voided', className: 'bg-slate-100 text-slate-700 border-slate-200' },
  refunded: { es: 'Reembolsado', en: 'Refunded', className: 'bg-rose-50 text-rose-800 border-rose-200' },
  partially_refunded: { es: 'Reembolso parcial', en: 'Partially refunded', className: 'bg-rose-50 text-rose-800 border-rose-200' },
  manual_verification_pending: { es: 'Verificación manual', en: 'Manual verify', className: 'bg-sky-50 text-sky-800 border-sky-200' },
  failed: { es: 'Fallido', en: 'Failed', className: 'bg-rose-50 text-rose-800 border-rose-200' },
  canceled: { es: 'Cancelado', en: 'Canceled', className: 'bg-slate-100 text-slate-700 border-slate-200' },
  draft: { es: 'Borrador', en: 'Draft', className: 'bg-slate-100 text-slate-700 border-slate-200' },
};

export const METHOD_LABEL = {
  stripe: 'Stripe (Tarjeta)',
  ath_movil: 'ATH Móvil',
  cash: 'Efectivo',
  check: 'Cheque',
  bank_transfer: 'Transferencia',
  other: 'Otro',
  pending: 'Pendiente',
  manual: 'Manual',
};
